<script setup lang="ts">
import {defineProps, computed} from 'vue';

const props = defineProps({
  height: {type: String || Number, default: 30},
  color: {type: String, default: '#000000'},
})

const height = computed(() => props.height)
const color = computed(() => props.color)
</script>

<template>
  <svg :width="height" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 9L15 15" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 9L9 15" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="12" cy="12" r="9" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped lang="less">

</style>
